// extracted by mini-css-extract-plugin
export default {"timeline-item__body-text":"styles_timeline-item__body-text__C2YdN","timeline-item--text-only":"styles_timeline-item--text-only__R5504"};